
const CircularProgress = () => {
  return <div className="tuby-progress-container">
    <img className="tuby-progress" src="/imgs/loading.svg" />
  </ div>;
};

export default CircularProgress;
